import React, { useState, useEffect } from 'react';
import DashboardGrid from './DashboardGrid';
import ErrorBoundary from '../support/ErrorBoundary';
import { LoadingState } from 'components/ui/loading-state';
import { ErrorState } from 'components/ui/error-state';
import dashboardCustomizationService from '../../services/dashboardCustomizationService';


const EnhancedDashboard = ({ 
  user, 
  onRoleSwitch, 
  onShowAIAssistant, 
  onShowNewCampaign, 
  showAIAssistant,
  notifications = []
}) => {
  const [dashboardConfig, setDashboardConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentRole, setCurrentRole] = useState(user?.role || 'marketer');

  // Mock user data - in real app this would come from props/context
  const mockUser = user || {
    name: 'John Smith',
    role: currentRole,
    roles: ['marketer', 'analyst', 'manager'],
    avatar: null
  };

  // Load dashboard configuration based on user role
  useEffect(() => {
    const loadDashboardConfig = async () => {
      try {
        setLoading(true);
        
        // Load configuration using the customization service
        const config = await dashboardCustomizationService.loadConfiguration(
          mockUser.id || 'user-1', 
          mockUser.role
        );
        
        setDashboardConfig(config);
        setError(null);
      } catch (err) {
        setError('Failed to load dashboard configuration');
        console.error('Dashboard config load error:', err);
      } finally {
        setLoading(false);
      }
    };

    loadDashboardConfig();
  }, [mockUser.role, mockUser.id]);



  // Handle role switching
  const handleRoleSwitch = async (newRole) => {
    if (onRoleSwitch) {
      onRoleSwitch(newRole);
    }
    
    // Update the current role state
    setCurrentRole(newRole);
    
    // Load configuration for new role using customization service
    try {
      const newConfig = await dashboardCustomizationService.loadConfiguration(
        mockUser.id || 'user-1', 
        newRole
      );
      setDashboardConfig(newConfig);
    } catch (err) {
      console.error('Failed to load configuration for new role:', err);
    }
  };

  // Loading state — mirrors the real dashboard layout so nothing shifts when
  // data arrives. The previous version used bare `bg-gray-200` blocks, which
  // stayed light grey on the dark canvas.
  if (loading) {
    return (
      <div className="p-4 sm:p-6">
        <LoadingState shape="page" label="Loading your dashboard" />
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="p-4 sm:p-6">
        <ErrorState
          title="Dashboard unavailable"
          description="We couldn't load your dashboard configuration. Your data is safe — this is only the layout."
          error={error}
          onRetry={() => window.location.reload()}
          retryLabel="Reload dashboard"
        />
      </div>
    );
  }

  return (
    <ErrorBoundary>
       <DashboardGrid 
          config={dashboardConfig}
          onConfigChange={setDashboardConfig}
        />
      {/* <div className="min-h-screen bg-gray-50 dark:bg-dark-700">
        <UnifiedHeader 
          user={mockUser}
          notifications={notifications}
          onRoleSwitch={handleRoleSwitch}
          onNotificationClick={(notification) => {
            console.log('Notification clicked:', notification);
          }}
          onShowAIAssistant={onShowAIAssistant}
          onShowNewCampaign={onShowNewCampaign}
          onShowProfile={() => console.log('Show profile')}
          onShowSettings={() => console.log('Show settings')}
          onLogout={() => console.log('Logout')}
        />
        
        <DashboardGrid 
          config={dashboardConfig}
          onConfigChange={setDashboardConfig}
        />
      </div> */}
    </ErrorBoundary>
  );
};

export default EnhancedDashboard;